// Mock data for Edusocial Landing Page

export const heroMetrics = [
  {
    number: "100+",
    label: "Industry Professionals"
  },
  {
    number: "25+",
    label: "Partner Colleges"
  },
  {
    number: "100%",
    label: "Placement Assistance"
  }
];

export const offerings = [
  {
    id: 1,
    title: "Industry Workshops",
    description: "Hands-on sessions led by industry experts covering latest trends and technologies"
  },
  {
    id: 2,
    title: "Masterclasses",
    description: "Deep-dive sessions on specialized topics by domain leaders and practitioners"
  },
  {
    id: 3,
    title: "Guest Lectures",
    description: "Interactive talks from successful professionals sharing real-world insights"
  },
  {
    id: 4,
    title: "Live Case Studies",
    description: "Real business scenarios analyzed and solved with industry mentors"
  },
  {
    id: 5,
    title: "Project Mentorship",
    description: "Personalized guidance on academic and industry-relevant projects"
  },
  {
    id: 6,
    title: "Mock Interviews & Vivas",
    description: "Practice sessions to prepare students for placements and assessments"
  }
];

export const benefits = [
  {
    id: 1,
    title: "Enhances Student Employability",
    description: "Bridge the skill gap with practical industry exposure, making students job-ready from day one."
  },
  {
    id: 2,
    title: "Strengthens Industry-Academia Collaboration",
    description: "Build lasting partnerships with industry leaders, creating mutual value and opportunities."
  },
  {
    id: 3,
    title: "Provides Practical Exposure",
    description: "Move beyond theory with real-world projects, case studies, and hands-on learning experiences."
  },
  {
    id: 4,
    title: "Improves Placement Readiness",
    description: "Comprehensive training and mentorship ensure students are confident and prepared for recruitment."
  },
  {
    id: 5,
    title: "Elevates Institutional Reputation",
    description: "Stand out as a forward-thinking institution committed to student success and industry relevance."
  }
];

export const partnershipModel = {
  eduSocialProvides: [
    "Curated network of 100+ industry professionals",
    "Structured curriculum aligned with industry needs",
    "End-to-end coordination of sessions and events",
    "Quality assurance and feedback mechanisms",
    "Regular student engagement activities"
  ],
  collegeProvides: [
    "Infrastructure and classroom facilities",
    "Student coordination and attendance management",
    "Integration with academic calendar",
    "Faculty liaison for smooth execution",
    "Feedback and continuous improvement support"
  ]
};

export const longTermValue = [
  {
    id: 1,
    title: "Stronger Placement Outcomes",
    description: "Students equipped with industry skills achieve better placement rates and career opportunities."
  },
  {
    id: 2,
    title: "Industry-Backed Ecosystem",
    description: "Create a sustainable learning environment with ongoing industry partnerships and support."
  },
  {
    id: 3,
    title: "Professional Network",
    description: "Students and faculty gain access to extensive professional networks and mentorship opportunities."
  },
  {
    id: 4,
    title: "Industry Recognition",
    description: "Position your institution as a leader in industry-integrated education and innovation."
  }
];

export const contactInfo = {
  email: "support@wldigital.in",
  phone: "+91-7022376856",
  tagline: "Learn. Connect. Inspire.",
  description: "Building Industry-Integrated Learning Ecosystems within educational institutions."
};

export const quickLinks = [
  { name: "For Colleges", href: "/" },
  { name: "For Mentors", href: "/for-mentors" },
  { name: "About Founder", href: "/about-founder" },
  { name: "Admin Dashboard", href: "/admin" }
];
